import API from '@/api/api'

const defaultData = {
  order     : 'name', // name, stationcount
  reverse   : false,
  offset    : 0,
  limit     : 100_000,
  hidebroken: true
}

export default {
  async getAll (data = {}, config = {}) {
    const endpoint = API.endpointConfig.tag.getAll

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  },

  async getByFilter (filter, data = {}, config = {}) {
    const endpoint = API.endpointConfig.tag.getByFilter
    endpoint.path = endpoint.path.replace('{filter}', filter || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  }
}
